import { render, staticRenderFns } from "./CommonBadge.vue?vue&type=template&id=0af76713"
import script from "./CommonBadge.vue?vue&type=script&lang=js"
export * from "./CommonBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports